export interface QuizFileAnswer {
  mediaFileId?: string;
  name?: string;
  mimeType?: string;
  size?: number | string;
}

export function isQuizFileAnswer(value: unknown): value is QuizFileAnswer {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  const file = value as QuizFileAnswer;
  return typeof file.mediaFileId === 'string' || typeof file.name === 'string';
}

export function quizFileLabel(value: unknown): string | null {
  if (!isQuizFileAnswer(value)) return null;
  const name = value.name?.trim();
  if (name) return name;
  return value.mediaFileId ? 'Archivo' : null;
}

export function hasQuizAnswer(value: unknown): boolean {
  if (typeof value === 'string') return value.trim() !== '';
  if (Array.isArray(value)) return value.some((item) => hasQuizAnswer(item));
  if (isQuizFileAnswer(value)) return Boolean(value.mediaFileId || value.name?.trim());
  return value !== undefined && value !== null;
}

export function quizFileHref(value: unknown): string | null {
  if (!isQuizFileAnswer(value) || !value.mediaFileId) return null;
  return `/api/media/files/${value.mediaFileId}/content`;
}
